var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-board"
  }, [_c('div', {
    staticClass: "main-board__head"
  }, [_c('h3', {
    staticClass: "text-28 text-md-22"
  }, [_vm._v("자료실")]), _c('router-link', {
    staticClass: "main-board__more",
    attrs: {
      "to": "/center/reference"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("더보기")])])], 1), _c('div', {
    staticClass: "main-board__body"
  }, [_c('div', {
    staticClass: "main-board-items"
  }, [!_vm.items.length ? _c('div', {
    staticClass: "main-board-item"
  }, [_vm._v(" 게시글이 없습니다. ")]) : _vm._e(), _vm._l(_vm.items, function (_ref) {
    var _id = _ref._id,
        subject = _ref.subject,
        createdAt = _ref.createdAt;
    return _c('router-link', {
      key: _id,
      staticClass: "main-board-item",
      attrs: {
        "to": "/center/reference/".concat(_id)
      }
    }, [_c('div', {
      staticClass: "main-board-item__tit"
    }, [_vm._v(_vm._s(subject))]), _c('span', {
      staticClass: "main-board-item__date"
    }, [_vm._v(_vm._s(createdAt.toDate()))])]);
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }